import createReactComponent from '../createReactComponent';
var ReplyAll = createReactComponent('ReplyAll', [['polyline', {
  points: '7 17 2 12 7 7',
  key: 't83bqg'
}], ['polyline', {
  points: '12 17 7 12 12 7',
  key: '1g4ajm'
}], ['path', {
  d: 'M22 18v-2a4 4 0 0 0-4-4H7',
  key: '1fcyog'
}]]);
export default ReplyAll;